/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Html_PlaceholderInputs */

const cs_builder_html_placeholder = /** @type {(inputs: Builder_Html_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začněte psát dokument… Vložte tokeny polí pro vázaná CRM pole.`)
};

const en_builder_html_placeholder = /** @type {(inputs: Builder_Html_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start writing your document… Insert field tokens for bound CRM fields.`)
};

/**
* | output |
* | --- |
* | "Start writing your document… Insert field tokens for bound CRM fields." |
*
* @param {Builder_Html_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_html_placeholder = /** @type {((inputs?: Builder_Html_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Html_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_html_placeholder(inputs)
	return cs_builder_html_placeholder(inputs)
});